<template>
  <v-layout>
    <v-navigation-drawer color="primary" app>
      Algumacoisa
    </v-navigation-drawer>

    <v-app-bar app>
      outra barra
    </v-app-bar>

    <v-main>
      <v-navigation-drawer color="warning" clipped fixed style="left: 256px; top: 64px">
        Algumacoisa
      </v-navigation-drawer>

      <v-content class="info" style="height: 200vh">
        <v-container fluid>
          <v-row>
            <v-col>
              Abobrinha
            </v-col>
          </v-row>
        </v-container>
      </v-content>
    </v-main>
  </v-layout>
</template>

<script>
  // @ is an alias to /src
  export default {
    name: "Home",
  };
</script>
